export default {
  GUEST: 'GUEST',
  CONTRIBUTOR: 'CONTRIBUTOR',
  CREATOR: 'CREATOR',
  PRODUCER: 'PRODUCER',
  BROADCASTER: 'BROADCASTER',
  ADMIN: 'ADMIN',
};
